import { render, staticRenderFns } from "./DynamicText.vue?vue&type=template&id=526e0baa&scoped=true&"
import script from "./DynamicText.vue?vue&type=script&lang=js&"
export * from "./DynamicText.vue?vue&type=script&lang=js&"
import style0 from "./DynamicText.vue?vue&type=style&index=0&id=526e0baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e0baa",
  null
  
)

export default component.exports